import PropTypes from 'prop-types';
import React from 'react';

import { useTranslation } from 'react-i18next';

import { Button, Icon, Header, Modal } from 'semantic-ui-react';

export default function DeleteAction({ event, done = () => {}, organization, selectedAttendees = [] }) {
    let [show, setShow] = React.useState(true);
    const { t } = useTranslation();

    const deleteAll = React.useCallback(() => {
        let deletions = selectedAttendees.map(attendee =>
            attendee.delete({
                organizationId: organization.id,
                eventId: event.id
            })
        );
        Promise.all(deletions)
            .then(() => {
                done();
            })
            .catch(e => {
                done(e);
            });
    }, [selectedAttendees, done]);

    let text = t('attendees.actionManager.delete.confirmation', {
        count: selectedAttendees.length
    });

    return (
        <Modal open={show} basic size="small">
            <Header icon="delete" content={text} />
            <Modal.Actions>
                <Button basic color="red" inverted onClick={() => setShow(false)}>
                    <Icon name="remove" /> No
                </Button>
                <Button color="green" inverted onClick={deleteAll}>
                    <Icon name="checkmark" /> Yes
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

DeleteAction.propTypes = {
    done: PropTypes.func.isRequired,
    event: PropTypes.object.isRequired,
    organization: PropTypes.object.isRequired,
    selectedAttendees: PropTypes.array.isRequired
};
